import React from "react";
import { SidebarProvider } from "@/components/ui/sidebar";
import { AppSidebar } from "@/components/AppSidebar";
import { AppHeader } from "@/components/AppHeader";
import ErrorBoundary from "@/components/ErrorBoundary";

interface AppShellProps {
  children: React.ReactNode;
}

export const AppShell = ({ children }: AppShellProps) => {
  return (
    <SidebarProvider defaultOpen={true}>
      <div className="min-h-screen flex w-full bg-background">
        <AppSidebar />
        
        <div className="flex-1 flex flex-col min-w-0">
          <AppHeader />
          
          <main className="flex-1 overflow-hidden">
            <ErrorBoundary fallback={
              <div className="flex items-center justify-center h-full">
                <div className="text-center p-8">
                  <h1 className="text-xl font-semibold text-destructive mb-2">
                    Content Error
                  </h1>
                  <p className="text-muted-foreground mb-4">
                    Something went wrong loading this section.
                  </p>
                  <button 
                    onClick={() => window.location.reload()}
                    className="px-4 py-2 bg-primary text-primary-foreground rounded-md hover:bg-primary/90"
                  >
                    Refresh
                  </button>
                </div>
              </div>
            }>
              {children}
            </ErrorBoundary>
          </main>
        </div>
      </div>
    </SidebarProvider>
  );
};